function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar / Calendar_Days"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10.6668 5.33268H9.60042C8.10695 5.33268 7.35966 5.33268 6.78923 5.62333C6.28746 5.87899 5.87981 6.28665 5.62415 6.78841C5.3335 7.35884 5.3335 8.10614 5.3335 9.59961V10.666M10.6668 5.33268H21.3335M10.6668 5.33268V2.66602M21.3335 5.33268H22.4004C23.8939 5.33268 24.6396 5.33268 25.21 5.62333C25.7118 5.87899 26.1208 6.28665 26.3765 6.78841C26.6668 7.35829 26.6668 8.10467 26.6668 9.59523V10.666M21.3335 5.33268V2.66602M5.3335 10.666V22.3996C5.3335 23.8931 5.3335 24.6394 5.62415 25.2099C5.87981 25.7116 6.28746 26.12 6.78923 26.3757C7.3591 26.666 8.10549 26.666 9.59604 26.666H22.4043C23.8948 26.666 24.6401 26.666 25.21 26.3757C25.7118 26.12 26.1208 25.7116 26.3765 25.2099C26.6668 24.64 26.6668 23.8947 26.6668 22.4041V10.666M5.3335 10.666H26.6668M21.3335 21.3327H21.3362L21.3361 21.3353L21.3335 21.3353V21.3327ZM16.0002 21.3327H16.0028L16.0028 21.3353L16.0002 21.3353V21.3327ZM10.6668 21.3327H10.6695L10.6694 21.3353L10.6668 21.3353V21.3327ZM21.3361 15.9993V16.002L21.3335 16.002V15.9993H21.3361ZM16.0002 15.9993H16.0028L16.0028 16.002L16.0002 16.002V15.9993ZM10.6668 15.9993H10.6695L10.6694 16.002L10.6668 16.002V15.9993Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.1a82d78c.svg";
export { ForwardRef as ReactComponent };